<template>
    <b-badge v-if="statusName || isWithdrawal" :variant="variant" pill>
        {{ displayText }}
    </b-badge>
</template>

<script>
import { BBadge } from "bootstrap-vue";

export default {
    name: "OrderStatusBadge",
    components: { BBadge },
    props: {
        row: {
            type: Object,
            required: true,
        },
    },
    computed: {
        isWithdrawal() {
            return this.row.FuelTransactionType === 0 || this.row.FuelTransactionType === 3 || this.row.FuelTransactionType === 5;
        },

        displayText() {
            if (this.isWithdrawal && !this.statusName) {
                return "Sipariş Dışı İşlem";
            }
            return this.statusName;
        },

        statusId() {
            if (this.row.OrderStatus !== null && this.row.OrderStatus !== undefined) {
                return this.row.OrderStatus;
            }

            if (this.row.FuelStorageInputTransactionDetails?.length > 0) {
                const firstDetail = this.row.FuelStorageInputTransactionDetails[0];
                if (firstDetail.FuelOrder?.OrderStatus !== null && firstDetail.FuelOrder?.OrderStatus !== undefined) {
                    return firstDetail.FuelOrder.OrderStatus;
                }
            }

            const nameToIdMap = {
                Planlandı: 0,
                "Sipariş Verildi": 1,
                "Bakiyeli Kapatıldı": 2,
                Kapatıldı: 3,
                "İptal Edildi": 4,
            };

            if (this.row.OrderStatusName && nameToIdMap[this.row.OrderStatusName] !== undefined) {
                return nameToIdMap[this.row.OrderStatusName];
            }

            return null;
        },

        statusName() {
            if (this.row.OrderStatusName) {
                return this.row.OrderStatusName;
            }

            const idToNameMap = {
                0: "Planlandı",
                1: "Sipariş Verildi",
                2: "Bakiyeli Kapatıldı",
                3: "Kapatıldı",
                4: "İptal Edildi",
            };

            if (this.statusId !== null) {
                return idToNameMap[this.statusId];
            }
            return null;
        },

        variant() {
            if (this.isWithdrawal && !this.statusName) {
                return "dark small";
            }

            const variantMap = {
                0: "info",
                1: "warning",
                2: "secondary",
                3: "success",
                4: "danger",
            };
            return variantMap[this.statusId] || "secondary";
        },
    },
};
</script>
